module.exports = "/_next/static/images/Wallet@3x-d79fee5376e4f8d6990a474beb040d1b.png";